module.exports = __webpack_public_path__ + "img/1_1-finanziario-palazzo-0.6c256ffe.png";